<template>
  <div class="Health_report">
    <div class="nav">
      <p style="font-size: 18px;font-weight: 700;text-align:center;color: rgba(0, 70, 145, 1);margin-top:50px">{{Data.year}}年</p>
      <h2>中国科学院大学学生心理健康报告</h2>
      <p style="color: #fff;background: linear-gradient(270deg, rgba(62, 60, 209, 1) 0%, rgba(53, 143, 254, 1) 100%);height: 30px;width: 320px;text-align:center;line-height:30px;border-radius:20px;margin:auto;margin-top:30px">中国科学院大学心理健康教育中心（{{yearss}}）</p>

      <p style="border-top: 1px dashed rgba(138, 164, 184, 1);margin-top:40px;"></p>
      <div class="cvs">
        <p>一、普测概况</p>
      </div>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">心理中心根据学工部和各培养单位提供的学生名单，{{Data.publishSubject}}应参测学生{{Data.avo.yccxs}}人。</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">在此次新生普测中，{{Data.avo.xy}}个学院、{{Data.avo.yjs}}个研究院所、{{Data.avo.lhpy}}个联合培养单位;共{{Data.avo.pydw }}个培养单位组织学生参加普测，实际参测学生{{Data.avo.sjccxs}}人，实际完整参测学生{{Data.avo.sjwzccxs}}人，完成比{{Data.avo.wcb}} 。</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">心理中心根据此次新生普测结果，向{{Data.avo.fxyj}}名学生提出风险预警和应对建议。心理中心通知相关培养单位给予关注，将未参加普测的同学也纳入关注范围，安排普测结果为中重度风险等级的学生参加排查访谈。</p>

      <div class="cvs">
        <p>二、参测学生人数</p>
      </div>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">1. 完成量表人数</p>
       <table>
          <thead>
              <tr>
                  <th>量表名称</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.bvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>


      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">2. 参测学生性别</p>

      <table>
        <thead>
              <tr>
                  <th>性别</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.cvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>


      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">3. 参测学生培养层次</p>
      <table>
        <thead>
              <tr>
                  <th>培养层次</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.dvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>
      <div class="cvs">
        <p>三、普测结果</p>
      </div>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">1. 整体数据</p>
      <table>
        <thead>
              <tr>
                  <th>重点情况</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.evoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">2. 情绪不稳定</p>


      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">参测学生中，呈现情绪不稳定的学生为{{Data.avo.qxbwdp}}人，涉及{{Data.avo.qxbwd}}个培养单位。</p>


    <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（1）性别比例</p>
      
      <table>
        <thead>
              <tr>
                  <th>性别</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.fvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（2）培养层次比例</p>
      <table>
        <thead>
              <tr>
                  <th>培养层次</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.ivoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">3. 心理健康水平低</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">参测学生中，呈现心理健康水平低的学生为{{Data.avo.xljkspdp}}人，涉及{{Data.avo.xljkspd}}个培养单位。</p>


    <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（1）性别比例</p>
      
      <table>
        <thead>
              <tr>
                  <th>性别</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.hvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（2）培养层次比例</p>
      <table>
        <thead>
              <tr>
                  <th>培养层次</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.ivoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">4. 中度以上抑郁</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">参测学生中，呈现中度以上抑郁学生为{{Data.avo.zdysyyp}}人，涉及{{Data.avo.zdysyy}}个培养单位。</p>


    <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（1）性别比例</p>
      
      <table>
        <thead>
              <tr>
                  <th>性别</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.jvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（2）培养层次比例</p>
      <table>
        <thead>
              <tr>
                  <th>培养层次</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.kvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">5. 曾经有过自杀意念</p>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">参测学生中，呈现曾经有过自杀意念的学生为{{Data.avo.cjygzsynp}}人，涉及{{Data.avo.cjygzsyn}}个培养单位。</p>
    <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（1）性别比例</p>
      <table>
        <thead>
              <tr>
                  <th>性别</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.lvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（2）培养层次比例</p>
      <table>
        <thead>
              <tr>
                  <th>培养层次</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.mvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>
      <div class="cvs">
        <p>四、风险预警</p>
      </div>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">1. 风险比例</p>
      <table>
        <thead>
              <tr>
                  <th>风险等级</th>
                  <th>人数（人）</th>
                  <th>百分比（%）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.nvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.percent}}</td>
              </tr>
          </tbody>
      </table>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">2. 性别比例</p>
      <table>
        <thead>
              <tr>
                  <th>风险等级</th>
                  <th>男生（人）</th>
                  <th>女生（人</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.ovoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.item1}}</td>
                  <td>{{item.item2}}</td>
              </tr>
          </tbody>
      </table>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">3. 培养层次比例</p>
      <table>
        <thead>
              <tr>
                  <th>风险等级</th>
                  <th>本科生（人）</th>
                  <th>硕士研究生（人）</th>
                  <th>博士研究生（人）</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item,i) in Data.pvoList" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.item1}}</td>
                  <td>{{item.item2}}</td>
                  <td>{{item.item3}}</td>
              </tr>
          </tbody>
      </table>
      <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">附件1：普测结果与风险等级对照表</p>
      <table>
        <thead>
              <tr>
                  <th style="width: 60px;">风险等级</th>
                  <th>风险标准</th>
                  <th style="width: 60px;">处理等级</th>
                  <th>建议措施</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>重度 <br> （4级）</td>
                  <td>满足以下任一条件：<br>1.SDS≥70  <br>2.SDS≥70并且UPIQ25=1</td>
                  <td>密切陪护</td>
                  <td style="text-align:center">心理辅导员或心理咨询师须及时与当事人谈心谈话，引导当事人就医或接受专业人员帮助，初步评估并向心理中心报告。如情况属实（症状显著，确有自杀计划或自杀未遂，仅有自杀意念可以列为中等），须及时密切陪护（至少两名同性别人员24小时陪护），联系监护人及时到场，及时转介就医。</td>
              </tr>
              <tr>
                  <td>中度<br>（3级）</td>
                  <td>满足以下任一条件：<br>1.70>SDS≥60  <br>2.UPIQ25=1</td>
                  <td>重点关注</td>
                  <td style="text-align:center !important;">心理辅导员应及时与当事人谈心谈话，引导当事人接受专业人员帮助，初步评估（是否有自杀计划，是否有精神障碍诊断）并向心理中心报告。如情况属实（排除自杀计划和严重精神障碍诊断，有长期内心冲突或人际关系不良），建议当事人预约心理咨询或就医诊断治疗，须重点关注（每周谈心谈话一次），及时与监护人联系了解情况并告知现状。</td>
              </tr>
              <tr>
                  <td>轻度<br>（2级）</td>
                  <td>60>SDS≥50并且UPIQ25=0</td>
                  <td>适当关注</td>
                  <td style="text-align:center">心理辅导员应适时与当事人谈心谈话，给予心理辅导，予以适当关注（每两周谈心谈话一次），找到监护人的联系方式，以便必要时可以及时沟通情况。</td>
              </tr>
              <tr>
                  <td>良好<br>（1级）</td>
                  <td>不满足以上任一条件</td>
                  <td>无</td>
                  <td style="text-align:center">无特别建议，保持正常的交流沟通即可。</td>
              </tr>
          </tbody>
      </table>
    </div>
    <el-dialog title="提示" :visible.sync="loading" width="30%">
        <div class="dis-s" style="text-align: center;">
        <img style="width: 200px;height: 200px;" src="../../assets/4092865.gif" alt="">
        <p style="font-size: 18px;">数据加载中，请稍等...</p>
      </div>
    </el-dialog>

    <el-button type="primary" style="position: fixed;top:200px;right:20px" @click="dcfub()">导出</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
        Data:'',
        loading:true,
        yearss:''
    }
  },
  methods: {

    dcfub(){
        this.$Http_Post('ScaleIssue/GetMentalHealthWord', { ReportType: this.ReportType[0], PublishID: this.PaperResultID[0], DeptID : this.DeptID[0] }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.open(res.Data, '_blank');
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

  },
  mounted() {

    
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    this.yearss = year +'-'+  month.toString()

    this.PaperResultID = [this.$route.query.PaperResultID];
    this.ReportType = [this.$route.query.ReportType];
    this.DeptID = [this.$route.query.DeptID];
    this.NianJI = [this.$route.query.NianJI];
    this.$Http_Post('ScaleIssue/GetMentalHealth', { ReportType: this.ReportType[0], PublishID: this.PaperResultID[0], DeptID: [this.$route.query.DeptID][0], NianJI: [this.$route.query.NianJI][0] }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.loading = false;
        this.Data = res.Data;
      }else{
        this.$router.push({path: "/Client/PuceReport"});
        this.Global.request_failure(res.Message);
      }
    })
  },
}
</script>
<style>
.Health_report{width: 100%;height: 100%;background: #fff;}
.Health_report .nav{width: 1000px;margin: auto;height: 100%;background-image: url('../../assets/12.png');overflow: auto;background-size:1000px}
.Health_report .nav h2{font-size: 28px;color: rgba(0, 103, 202, 1);text-align: center;padding-top: 30px;}
.Health_report .nav .cvs{background: linear-gradient(90deg, rgba(53, 142, 253, 0.1) 0%, rgba(62, 61, 210, 0.1) 100%);height: 45px;width: 320px;line-height: 45px;border-radius: 25px;color: rgba(0, 103, 202, 1);margin-top: 30px;text-indent: 40px;margin-left: -20px;font-weight: 700;font-size: 18px;
}
.Health_report table {border-collapse: collapse; width: 80%;margin: 20px auto;font-family: Arial, sans-serif;}
.Health_report th,td {border: 1px solid #ddd;padding: 12px;text-align: left;text-align: center;}
th {background-color: #f2f2f2;color: #333;}
/* tr:nth-child(even) {background-color: #f9f9f9;} */
.Health_report tr:hover {background-color: #e5f6ff;}
</style>
